/* eslint camelcase: 0, no-undef: 0*/
// Initial loading point for the client application

__webpack_public_path__ = window.__webpack_public_path__;

/**
 * Styles
 */
require('./styles/main.less');

/**
 * React application
 */
require('../../startup/app');


